import React from 'react'
import { FormattedMessage } from 'react-intl'

import {
  TableHead,
  TableHeader,
  TableRow,
} from '../../../../../../../../../shadcn/components/ui/table'
import Icon, { IconName } from '../../../../../../../../atoms/icons/icon'
import { VAT_STATUS } from '../../../../../../../../contexts'

const QuoteSectionBodyTableHeader = ({
  icon,
  label,
  vatStatus,
  hasActions,
  isDragDisabled,
}: {
  icon?: IconName
  label: string
  vatStatus: VAT_STATUS
  hasActions: boolean
  isDragDisabled: boolean
}) => {
  return (
    <TableHeader key={label} className='sticky top-0 bg-grey-300 p-3'>
      <TableRow className='border-none'>
        {!isDragDisabled && (
          <TableHead className='text-left font-semibold text-grey-800'></TableHead>
        )}
        <TableHead className='flex items-center gap-2 text-left font-semibold text-black'>
          {icon && <Icon size={15} name={icon} />}
          {label}
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.unit'
            defaultMessage='Unité'
          />
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.commission'
            defaultMessage='Com.'
          />
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.quantity'
            defaultMessage='Qté'
          />
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.unitPrice'
            defaultMessage='PU {unitPriceLabel}'
            values={{
              unitPriceLabel:
                vatStatus === VAT_STATUS.HT ? (
                  <FormattedMessage
                    id='ui.QuoteSectionBodyTableHeader.exclVat'
                    defaultMessage='HT'
                  />
                ) : (
                  <FormattedMessage
                    id='ui.QuoteSectionBodyTableHeader.inclVat'
                    defaultMessage='TTC'
                  />
                ),
            }}
          />
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.totalHT'
            defaultMessage='Total HT'
          />
        </TableHead>
        <TableHead className='text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.vat'
            defaultMessage='TVA'
          />
        </TableHead>
        <TableHead className='whitespace-nowrap text-left font-semibold text-grey-800'>
          <FormattedMessage
            id='ui.QuoteSectionBodyTableHeader.totalTTC'
            defaultMessage='Total TTC'
          />
        </TableHead>
        {hasActions && (
          <TableHead className='text-left font-semibold text-grey-800' />
        )}
      </TableRow>
    </TableHeader>
  )
}

export default QuoteSectionBodyTableHeader
